export interface ComposedSection {
  title: string;
  body: string;
  /** True for the sections PromptComposerService adds after the base prompt. */
  appended: boolean;
}

/**
 * The headings the composer writes, and only those. A base prompt is free to
 * contain its own dashed headings, so treating every `--- x ---` line as a
 * boundary would report text the composer never touched as appended.
 */
const COMPOSER_MARKERS = ['Org Context', 'Additional Skills', 'Custom Instructions'] as const;

const MARKER_LINES = new Map<string, string>(
  COMPOSER_MARKERS.map((title) => [`--- ${title} ---`, title]),
);

export function splitComposedPrompt(composed: string): ComposedSection[] {
  const sections: ComposedSection[] = [{ title: 'Base prompt', body: '', appended: false }];
  const buffers: string[][] = [[]];

  for (const line of composed.split('\n')) {
    const marker = MARKER_LINES.get(line.trim());

    if (marker) {
      sections.push({ title: marker, body: '', appended: true });
      buffers.push([]);
      continue;
    }

    buffers[buffers.length - 1].push(line);
  }

  return sections.map((section, index) => ({ ...section, body: buffers[index].join('\n').trim() }));
}

export function sectionTestId(title: string): string {
  return `composed-section-${title.toLowerCase().replace(/\s+/g, '-')}`;
}
